import {  Component ,  OnInit } from '@angular/core';

@Component({
  selector: 'app-info-logged-user',
  templateUrl: './info-logged-user.component.html',
  styleUrls: ['./info-logged-user.component.css']
})
export class InfoLoggedUserComponent implements OnInit {

  currentUser:any={};
  userGoogle:any = {};
  userGoogleResponse:any = {};
  userBackend:any = {};

  userGoogleFields = [
    {title:"ID",field:"id",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"Provider",field:"provider",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"Email",field:"email",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"Nome completo",field:"name",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"Nome",field:"firstName",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"Cognome",field:"lastName",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"PhotoUrl",field:"photoUrl",type:"text",styleClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},
  ];
  userGoogleResponseFields = [
    {title:"login_hint",field:"login_hint",type:"text",styleClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},
    {title:"scope",field:"scope",type:"text",styleClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},
    {title:"token_type",field:"token_type",type:"text",styleClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},
  ];

  userBackendFields = [
    {title:"principal",field:"principal",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"name",field:"name",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"email",field:"email",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"details",field:"details",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"credentials",field:"credentials",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
    {title:"authenticated",field:"authenticated",type:"text",styleClass:"col-lg-4 col-md-6 col-sm-12 col-xs-12"},
  ];

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.userGoogle = this.currentUser.userGoogle;
    this.userGoogleResponse = this.currentUser.userGoogle.response;
    this.userBackend = this.currentUser.userBackend;
  }


  //authorities
  labelKeys_authorities=["authority"];
  onChangeItemList_authorities($event){
    console.log($event);
  }

  //storeIds
  labelKeys_storeIds=["id"];
  onChangeItemList_storeIds($event){
    console.log($event);
  }
  


}
